<template>
  <button type="button" class="close" aria-label="Close" v-bind="$attrs">
    <span aria-hidden="true">&times;</span>
  </button>
</template>
